import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/core/components/ui/dialog";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { dayjs } from "@/core/utils/date";
import { CollapsibleSection } from "@/payroll/ai-script/ai-script-explanation-chat/collapsible-section";
import type {
  IPackChatSource,
  PackChatSourceAccess,
} from "@/payroll/pack-chat/types";
import { SourceStatement } from "./source-statement";

/** Sources identify a captured statement; the authorized route serves its current view. */
export const PackChatSource = ({
  source,
  access,
}: {
  source: IPackChatSource;
  access: PackChatSourceAccess;
}) => {
  const [open, setOpen] = useState(false);
  const captured = dayjs(source.captured_at).format("MMM D, YYYY, h:mm A");
  return (
    <CollapsibleSection label="Source">
      <Stack gap="xs" align="start">
        <Typography variant="captionW1" textColor="tertiary">
          PayPack captured {captured}
        </Typography>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="text-xs text-secondary-text underline underline-offset-2 transition-colors hover:text-primary-text"
        >
          View source PayPack
        </button>
      </Stack>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="flex h-[85dvh] max-w-2xl flex-col overflow-hidden">
          <DialogHeader>
            <DialogTitle>Source PayPack</DialogTitle>
            <DialogDescription className="not-sr-only text-left">
              AI used the statement captured {captured}. This view shows the
              statement available now. Later changes may differ from the AI
              source.
            </DialogDescription>
          </DialogHeader>
          <div className="min-h-0 flex-1">
            {open && <SourceStatement source={source} access={access} />}
          </div>
        </DialogContent>
      </Dialog>
    </CollapsibleSection>
  );
};
